import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AdminSidebar from "./adminSidebar";
import DownloadData from "./downloadata";
import UploadPDF from "./uploadpdf";
import AnalyticalDashboard from "./analyticaldashboard";

function AdminDashboard() {

    const navigate = useNavigate();
    const [active, setActive] = useState("instruction");
    const [alertData, setAlertData] = useState(null);

    const location = useLocation();
    useEffect(() => {
        if (location.state?.message) {
            setAlertData({
                message: location.state.message,
                id: Date.now()
            });
        }
    }, [location.state]);

    useEffect(() => {
        if (alertData) {
            const timer = setTimeout(() => setAlertData(null), 5000);
            return () => clearTimeout(timer);
        }
    }, [alertData]);


    useEffect(() => {

        const token = sessionStorage.getItem("adminToken");

        if (!token || token === "null" || token === "undefined") {

            sessionStorage.clear();

            navigate("/AdminLogin", {
                replace: true,
                state: { message: "Please login to continue ❗" }
            });
        }

    }, [navigate]);

    return (
        <>
            <style>
                {`
                    .admin-container{
                        display:flex;
                        min-height:100vh;
                        background:#f8fafc;
                        font-family:"Poppins",sans-serif;
                    }

                    .admin-content{
                        flex:1;
                        padding:24px;
                    }

                    .instruction-box{
                        background:white;
                        border-radius:16px;
                        padding:28px;

                        box-shadow:0 2px 12px rgba(0,0,0,0.05);

                        border:1px solid #e2e8f0;
                    }

                    .instruction-box h2{
                        margin:0 0 18px;
                        color:#1e3a8a;
                        font-size:24px;
                    }

                    .instruction-box ul{
                        padding-left:20px;
                        margin:0;
                    }

                    .instruction-box li{
                        margin-bottom:14px;
                        color:#475569;
                        line-height:1.6;
                        font-size:15px;
                    }

                    .instruction-note{
                        margin-top:22px;
                        padding:14px 18px;

                        background:#eff6ff;
                        border-left:4px solid #2563eb;

                        border-radius:10px;

                        color:#1e40af;
                        font-size:14px;
                        font-weight:500;
                    }

                    @media (max-width:768px){

                        .admin-container{
                            flex-direction:column;
                        }

                        .admin-content{
                            padding:14px;
                        }

                        .instruction-box{
                            padding:20px;
                        }

                        .instruction-box h2{
                            font-size:20px;
                        }

                        .instruction-box li{
                            font-size:14px;
                        }
                    }
                `}
            </style>

            <div className="admin-container">

                {/* Sidebar */}
                <AdminSidebar
                    active={active}
                    setActive={setActive}
                />

                {/* Right Side */}
                <div className="admin-content">

                    {/* Instruction Section */}
                    {active === "instruction" && (

                        <div className="instruction-box">

                            <h2>Admin Instructions</h2>

                            <ul>
                                <li>
                                    Verify all student application details carefully before approval.
                                </li>

                                <li>
                                    Check uploaded photo and signature for clarity and correctness.
                                </li>

                                <li>
                                    Ensure payment status is verified before generating reports.
                                </li>

                                <li>
                                    Use the Reports section to download application and payment data.
                                </li>

                                <li>
                                    Logout properly after completing admin operations.
                                </li>
                            </ul>

                            <div className="instruction-note">
                                Note: All admin activities are monitored and logged by the system.
                            </div>

                        </div>
                    )}

                    {/* Download Section */}
                    {active === "download" && (
                        <DownloadData />
                    )}

                    {/* Download Section */}
                    {active === "analyticaldashboard" && (
                        <AnalyticalDashboard />
                    )}

                    {/* uploadpdf Section */}
                    {active === "uploadpdf" && (
                        <UploadPDF />
                    )}



                </div>

            </div>
        </>
    );
}

export default AdminDashboard;